import { baseApiClient } from 'api/BaseApiClient';
import type {
  ChecklistResponse,
  OnboardingStateResponse,
  SetupRequest,
  StepStatus,
  SyncResponse,
} from 'entities/onboarding/types';

const BASE_URL = '/v1/onboarding';

// Typed wrappers for the onboarding endpoints (apps/onboarding). Auth headers are added by the client.
export const onboardingApi = {
  getState: (): Promise<OnboardingStateResponse> => baseApiClient.get(`${BASE_URL}/state`),

  setup: (data: SetupRequest): Promise<OnboardingStateResponse> => baseApiClient.post(`${BASE_URL}/setup`, data),

  getChecklist: (): Promise<ChecklistResponse> => baseApiClient.get(`${BASE_URL}/checklist`),

  updateStep: (stepId: string, status: StepStatus): Promise<unknown> =>
    baseApiClient.patch(`${BASE_URL}/checklist/${stepId}`, { status }),

  syncChecklist: (): Promise<SyncResponse> => baseApiClient.post(`${BASE_URL}/checklist/sync`, {}),
};
